import { Inject } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-allocation-history',
  templateUrl: './allocation-history.component.html',
  styleUrls: ['./allocation-history.component.css']
})
export class AllocationHistoryComponent implements OnInit {
  allocationHistoryList: any;
  portfolioList: any[];
  bucketList: any;
  bankList: any[];
  searchLoaded: boolean;
  bankid: any;
  bucketid: any;
  portfolioid: any;

  constructor(private _api:ApiService, @Inject(SESSION_STORAGE) private storage: StorageService) { }

  ngOnInit(): void {
    this.searchLoaded = false;

    let a = {
      client_id:this.getFromLocal('Client_ID'),
     }
    this._api.getlist_bank_details(a).subscribe(data=>{
      if (data['Code']  == 200) {
        this.bankList = data['Data']
      } else {
        this.bankList = [];
      }
    });


    this._api.portfolio_type_list(a).subscribe(data=>{
      if (data['Code']  == 200) {
        this.portfolioList = data['Data']
      } else {
        this.portfolioList = [];
      }
    });

    this._api.getBucketList().subscribe(data=>{
      if (data['Code'] == 200) {
        this.bucketList = data['Data'];
      } else {
        this.bucketList = [];
      }
    });
  }


  getFromLocal(key): any {
    return this.storage.get(key);
  }


  search(){
    const dataFormat = {
      bank_id : this.bankid,
      bucket_id : this.bucketid,
      portfolio_id : this.portfolioid,
      product_id : "1"
    };

    this._api.getallocation_history(dataFormat).subscribe(data=>{
      if (data['Code'] == 200) {
        this.allocationHistoryList = data['Data'];
      } else {
        this.allocationHistoryList = [];
      }
    });

    this.searchLoaded = true;
  }

}
